// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xCsG","left":"styles_left__1fMQ7","desktopActions":"styles_desktopActions__6tbZV","title":"styles_title__1EiRf"};